module.exports = __webpack_public_path__ + "static/logoSolares-a35b92caf01a2347a807540a890a302b.png";